module.exports = "\n<app-applicant-menu></app-applicant-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/applicant.component.html
// module id = ./src/app/applicant/applicant.component.html
// module chunks = main